import { PropsWithChildren, useState, useEffect } from 'react';
import ReactDOM from 'react-dom';

interface PortalProps {
  id?: string; // Optional string prop
}

const Portal = ({ id = '', children }: PropsWithChildren<PortalProps>) => {
  const [portalRoot, setPortalRoot] = useState<HTMLElement>();

  useEffect(() => {
    if (typeof document === 'undefined') return undefined;
    let root = document.getElementById(id);
    if (!root) {
      root = document.createElement('div');
      root.id = id;
      document.body.appendChild(root);
    }
    setPortalRoot(root);
    return () => portalRoot
    && (children as Node[])?.forEach(child => portalRoot.removeChild(child));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return portalRoot && ReactDOM.createPortal(children, portalRoot);
};

export default Portal;
